import { createFileRoute } from "@tanstack/react-router";
import EpisodesPlayerSkeleton from "@/modules/EpisodesPlayer/EpisodesPlayerSkeleton";
import { redirectSeriesDeeplink } from "@/lib/seriesDeeplink";

// Legacy camelCase mobile deeplink `/seriesPlayer/{id}`, still in the wild.
export const Route = createFileRoute("/_videoPlayer/seriesPlayer/$id")({
  loader: ({ params, location }) =>
    redirectSeriesDeeplink(location.search, { pathId: params.id }),
  pendingMs: 0,
  pendingMinMs: 0,
  pendingComponent: EpisodesPlayerSkeleton,
});
